export const SETTING_ROUTE_NAMES = {
  ROOT: 'setting',
  FEES: 'fees',
  TAXES: 'taxes',
  MISC: 'misc',
  MAILCHIMP: 'mailchimp',
  PAYMENTS: 'payments',
  PAYMENTS2: 'payments2',
  SETUP: 'setup',
  CHECKOUT: 'checkout',
  EMAIL_TEMPLATES: 'email-templates',
}
